module.exports = __webpack_public_path__ + "img/signup-bg.4df5c4c4.png";